export enum PaymentPeriod {
  MONTHLY = 'monthly'
}

export enum AgreementType {
  PREVIEW,
  PRODUCT,
  TRANSPORT,
  BIKE,
  BTM
}
